// Styles
import "./editorial-description-slider.scss";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorialSlider = (context) => {
  const editorialSliderSection = context.closest(".shopify-section");
  if (!editorialSliderSection) return;

  const sliderContainer = editorialSliderSection.querySelector(
    ".editorial-description-slider__images-wrapper"
  );
  if (sliderContainer) {
    new Swiper(sliderContainer, {
      loop: false,
      slidesPerView: 1.12,
      spaceBetween: 2,
      navigation: {
        nextEl: sliderContainer.querySelector(".editorial-description-slider__navigation-next"),
        prevEl: sliderContainer.querySelector(".editorial-description-slider__navigation-prev"),
      },
      breakpoints: {
        990: {
          slidesPerView: 3,
        }
      }
    });
  }
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".editorial-description-slider__container"),
    (el) => {
      window.dAgency.initEditorialSlider(el);
    }
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".editorial-description-slider__container"),
      (el) => {
        window.dAgency.initEditorialSlider(el);
      }
    );
  });
}
